export var ContextGLTextureFormat;
(function (ContextGLTextureFormat) {
    ContextGLTextureFormat[ContextGLTextureFormat["BGRA"] = 0] = "BGRA";
    ContextGLTextureFormat[ContextGLTextureFormat["BGRA_PACKED"] = 1] = "BGRA_PACKED";
    ContextGLTextureFormat[ContextGLTextureFormat["BGR_PACKED"] = 2] = "BGR_PACKED";
    ContextGLTextureFormat[ContextGLTextureFormat["COMPRESSED"] = 3] = "COMPRESSED";
    ContextGLTextureFormat[ContextGLTextureFormat["COMPRESSED_ALPHA"] = 4] = "COMPRESSED_ALPHA";
})(ContextGLTextureFormat || (ContextGLTextureFormat = {}));
